import { Description, Dialog, DialogPanel, DialogTitle, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { GQLHelpArticleFragment } from '@theprintbar/graphql';
import { WebRoutes } from '@theprintbar/shared';
import { ButtonSize, OutlineButton, OutlineLinkButton, RichText, SmallArrowIcon } from '@theprintbar/ui';
import React, { Fragment } from 'react';

interface FAQModalProps {
	question: GQLHelpArticleFragment;
	isOpen?: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export function FAQModal({ question, isOpen, setIsOpen }: FAQModalProps) {
	return (
		<Transition
			show={isOpen ?? false}
			as={Fragment}
			enter="transition duration-300 ease-out"
			enterFrom="transform scale-95 opacity-0"
			enterTo="transform scale-100 opacity-100"
			leave="transition duration-200 ease-in"
			leaveFrom="transform scale-100 opacity-100"
			leaveTo="transform scale-95 opacity-0"
		>
			<Dialog open={isOpen ?? false} onClose={() => setIsOpen(false)} className="relative z-50">
				<div className="fixed inset-0 bg-grey/70" aria-hidden="true" />
				<div className="fixed inset-0 flex w-screen items-center justify-center p-4">
					<DialogPanel className="relative text-blue w-full max-w-md lg:max-w-lg xl:max-w-2xl rounded-3xl border border-blue bg-blue-bright p-8 lg:p-16">
						<OutlineButton
							className="absolute p-1 rounded-full top-4 right-4 lg:right-8 lg:top-8"
							onClick={() => setIsOpen(false)}
						>
							<XMarkIcon className="w-3 h-3 lg:w-5 lg:h-5" />
						</OutlineButton>
						<DialogTitle className="lg:text-lg text-sm uppercase font-semibold font-sans">{question.title}</DialogTitle>
						<RichText className="space-y-2 mt-4" content={question.content} />
						<OutlineLinkButton
							to={WebRoutes.HelpCategoryPage(question.category.slug, question.id)}
							className="mt-7"
							size={ButtonSize.S}
							icon={SmallArrowIcon}
						>
							<h5 className="uppercase">More Info</h5>
						</OutlineLinkButton>
					</DialogPanel>
				</div>
			</Dialog>
		</Transition>
	);
}
